import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_INTERACTION} from '../../metamodel/Concept';

export default class BusinessInteractionNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_INTERACTION;
	}
}
